import FirstSlider from './allSlider/FirstSlider';
import ThirdSlider from './allSlider/ThirdSlider';
import FourthSlider from './allSlider/FourthSlider';
import FifthSlider from './allSlider/FifthSlider';
import SixSlider from './allSlider/SixSlider';
import SecondSlider from './allSlider/SecondSlider';

export default function FilterSlider({ setCheckedFilters, sliderData }) {

    const handleCategoryClick = (category) => {
        setCheckedFilters({ [category]: true });
    };
    return (
        <>
            <div className="card-item">
                <FirstSlider sliderData={sliderData?.deliveryRestaurant} />
                <SecondSlider handleClick={handleCategoryClick} />
                <ThirdSlider sliderData={sliderData?.fineDining} />
                <FourthSlider sliderData={sliderData?.modePricedRestaurants} />
                <FifthSlider sliderData={sliderData?.cheapEats} />
                <SixSlider sliderData={sliderData?.breakfast} />
            </div>
        </>
    )
}
